import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ErrorIcon from "../../../assets/images/404-image.png";

const SomethingWentWrong = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.classList.add("gray-background");
  }, []);
 

  return (
    <Container className="wentwrong">
      <Row>
        <Col lg={{ span: 8, offset: 2 }}>
          <div role="alert" aria-live="assertive" className="wentwrong__block">
            <img
              src={ErrorIcon}
              alt="Error Icon"
              aria-hidden="true"
              className="wentwrong__block-icon"
            />
            <h1 className="wentwrong__block-title">
              {t("pages.pageNotFound.title")}
            </h1>           
            <h6 className="wentwrong__block-desc">
              {t("pages.pageNotFound.desc")}
            </h6>
            {/* <div className="wentwrong__block-linkDesc">
            {t("pages.pageNotFound.ctPaidLeave")} <a className="wentwrong__block-link" href="https://ctpaidleave.org"> {t("pages.pageNotFound.clickHere")} <img src={RightArrow} alt="Arrow Icon" aria-hidden="true" /></a>
            </div>
            <div className="wentwrong__block-linkDesc">
            {t("pages.pageNotFound.ctBusiness")} <a className="wentwrong__block-link" href="https://business.ct.gov"> {t("pages.pageNotFound.clickHere")} <img src={RightArrow} alt="Arrow Icon" aria-hidden="true" /></a>
            </div> */}
            
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default SomethingWentWrong;